import "../MainDashboard.scss";
import commaSeparator from "../../../../../Utils/CommaSeparator";

const OrderCodeSection = ({initialData}) => {

  return (
    <div className="main-order-code-section">
      <div className="code">
        <p>{initialData?.status}</p>
        <p>/</p>
        <p>کد سفارش :</p>
        <h6>{initialData?.orderId}</h6>
      </div>
      <div className="box-order-code">
        <div className="row">
          <div className="imageTik">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12 2C6.49 2 2 6.49 2 12C2 17.51 6.49 22 12 22C17.51 22 22 17.51 22 12C22 6.49 17.51 2 12 2ZM16.78 9.7L11.11 15.37C10.97 15.51 10.78 15.59 10.58 15.59C10.38 15.59 10.19 15.51 10.05 15.37L7.22 12.54C6.93 12.25 6.93 11.77 7.22 11.48C7.51 11.19 7.99 11.19 8.28 11.48L10.58 13.78L15.72 8.64C16.01 8.35 16.49 8.35 16.78 8.64C17.07 8.93 17.07 9.4 16.78 9.7Z"
                fill="#EE6900"
              />
            </svg>
          </div>
          <p>{initialData?.checkVz}</p>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="4"
            height="4"
            viewBox="0 0 4 4"
            fill="none"
          >
            <circle cx="2" cy="2" r="2" fill="#DADADA"/>
          </svg>

          <div className="inline-row">
            <p>تاریخ :</p>
            <h6>{initialData?.date}</h6>
          </div>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="4"
            height="4"
            viewBox="0 0 4 4"
            fill="none"
          >
            <circle cx="2" cy="2" r="2" fill="#DADADA"/>
          </svg>

          <div className="inline-row">
            <p>مبلغ :</p>
            <h6>{commaSeparator(initialData?.totalAmount)}&nbsp; ریال</h6>
          </div>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="4"
            height="4"
            viewBox="0 0 4 4"
            fill="none"
          >
            <circle cx="2" cy="2" r="2" fill="#DADADA"/>
          </svg>

          <div className="inline-row">
            <p>تخفیف :</p>
            <h6>{commaSeparator(initialData?.offer)}&nbsp; ریال</h6>
          </div>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="4"
            height="4"
            viewBox="0 0 4 4"
            fill="none"
          >
            <circle cx="2" cy="2" r="2" fill="#DADADA"/>
          </svg>

          {/* <div className="inline-row">
            <p>مالیات :</p>
            <h6>{commaSeparator(initialData?.mal)}&nbsp; ریال</h6>
          </div>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="4"
            height="4"
            viewBox="0 0 4 4"
            fill="none"
          >
            <circle cx="2" cy="2" r="2" fill="#DADADA" />
          </svg>

          <div className="inline-row">
            <p>مبلغ خدمات:</p>
            <h6>{commaSeparator(initialData?.sendPrice)}&nbsp; ریال</h6>
          </div> */}
        </div>

        <div className="row-two">
          {initialData?.items?.map((v, index) => (
            <div key={index} className="img-title">
              <img src={v?.image} alt=""/>
              <div className="in-box">
                <p>{v?.productName}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default OrderCodeSection;
